/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('SbfTimeSlotMember', SbfTimeSlotMember);

    SbfTimeSlotMember.$inject = ['$resource', 'DateUtils'];

    function SbfTimeSlotMember ($resource, DateUtils) {
        var resourceUrl =  'api/member/sbf-time-slots/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromTime = DateUtils.convertDateTimeFromServer(data.fromTime);
                        data.toTime = DateUtils.convertDateTimeFromServer(data.toTime);
                    }
                    return data;
                }
            }
        });
    }
})();
